import {inject, Injectable} from '@angular/core';
import {getStorage, ref as storageRef, uploadBytes, deleteObject, getDownloadURL} from "@angular/fire/storage";
import {ImageInfo} from "../types/image-info";
import {Database} from "@angular/fire/database";
import {get, ref} from "@angular/fire/database";
import {CompanySettingsClientService} from "./company-settings-client.service";
import {logger} from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class FavIconService {

    database = inject(Database);
    private readonly settings = inject(CompanySettingsClientService);

    public waitingForImage = false;

    storage;
    storageRef;

    constructor() {
        this.storage = getStorage();
        this.storageRef = storageRef(this.storage, 'product-images/null');
    }

    async setFavIcon(image: File, companyId: string) {

        await this.removeFavIcon(companyId);

        //  this.waitingForImage = true;
        this.storageRef = storageRef(this.storage, 'companies/' + companyId + "/favIcon");
        // 'file' comes from the Blob or File API
        await uploadBytes(this.storageRef, image)

        const reader = new FileReader();
        reader.onloadend = () => {

            const base64String = reader.result as string;

            const body = {
                fileBase64: base64String
            };
                return new Promise((resolve, reject) => {
                    resolve("");
                });
        }

        reader.readAsDataURL(image);

        return companyId;
    }

    async getFavIocn(companyId: string) {
        try {
            return await getDownloadURL(storageRef(this.storage, 'companies/' + companyId + "/favIcon_512x512")).then((url) => {
                return url;
            });
        } catch (e) {
            try {
                return await getDownloadURL(storageRef(this.storage, 'companies/' + companyId + "/favIcon")).then((url) => {
                    return url;
                });
            } catch (e) {
                return this.getStandardFavIcon();
            }
        }
    }

    async removeFavIcon(companyId: string) {
        const desertRef = storageRef(this.storage, 'companies/' + companyId + "/favIcon");
        // Delete the file
        deleteObject(desertRef).then(() => {
            // File deleted successfully
        }).catch((error) => {
            // Uh-oh, an error occurred!
            const desertRef = storageRef(this.storage, 'companies/' + companyId + "/favIcon_512x512");
            // Delete the file
            deleteObject(desertRef).then(() => {
                // File deleted successfully
            }).catch((error) => {
                // Uh-oh, an error occurred!
            });
        });
    }

    async getStandardFavIcon() {
        return getDownloadURL(storageRef(this.storage, 'common/favIcon')).then((url) => {
            return url;
        }).catch(async (e) => {
            return getDownloadURL(storageRef(this.storage, 'common/favIcon_512x512')).then((url) => {
                return url;
            }).catch((e) => {
                return "";
            });
        });
    }

    async updateCompanyFavIconData(_companyId: string, imageInfo: ImageInfo) {
        await this.settings.patchGroup('fav-icon', {
            name: imageInfo.name,
            height: imageInfo.height,
            width: imageInfo.width,
            fileSize: imageInfo.fileSize,
        });
    }

    async getCompanyFavIconData(companyId: string): Promise<ImageInfo | null> {
        const companyRef = ref(this.database, 'companies/' + companyId + '/favIconInfo');

        const snapshot = await get(companyRef);
        if (snapshot.exists()) {
            return snapshot.val();
        } else {
            logger.error('no matching condition found');
            return null;
        }
    }
}
